import React, { Component } from 'react';
import { Col, Row, ListGroup, ListGroupItem, Container, Badge, UncontrolledTooltip } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { AgregarProductoPedidoMasivo, AgregarNuevoProductoPedidoMasivo } from '../../store/sagas/carritoApi';
import { notificacion } from '../../utilitarios/util';
import { AuthContext } from "../../store/provider/AuthProvider";
import { data } from '../../constants/Constants';
import Spinner from "../reusable/Loader";
import TooltipLeyenda from '../reusable/TooltipLeyenda';

export class DetallePedido extends Component {
  static displayName = DetallePedido.name;
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      detallePedido: {},
      trakingDetalle: [],
      detalle: [],
      dealer: {},
      linea: {},
      estado: {}
    };
  }

  checkParams(fn = () => { }) {
    const { state } = this.props.location;
    this.setState({
      detallePedido: state.detallePedido,
      loading: false,
      detalle: state.detalle,
      trakingDetalle: state.trakingDetalle || [],
      dealer: state.dealer,
      linea: state.linea,
      estado: state.estado
    }, fn);
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.checkParams();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }
  addPedidos(carritoProdctos, setcarritoProdctos, pantalla) {
    this.setState({ loading: true });

    const correo = this.state.dealer.correoElectronico
    const codcliente = this.state.dealer.codcliente
    const centro = this.state.linea.centro
    const linea = this.state.linea.linea
    const vkorg = this.state.linea.vkorg
    const almacen = this.state.linea.almacen
    const canal = this.state.linea.canal
    const sector = this.state.linea.sector

    let ListaProductos = [];
    this.state.detalle.filter(function (item) {
      ListaProductos.push({
        "CorreoElectronicoDealer": correo,
        "DispositivoDealer": null,
        "Descripcion": item.maktx,
        "CantidadOriginal": item.canti,
        "Moneda": item.waers,
        "Pantalla": pantalla.HistorialPedido.Detalle,
        "UnidadMedida": item.meins,
        "PrecioFinal": item.precio,
        "Codigo": item.matnr,
        "CodigoDealer": codcliente,
        "Centro": centro,
        "Linea": linea,
        "Vkorg": vkorg,
        'Almacen': almacen,
        'Canal': canal,
        'Sector': sector
      });
    });


    AgregarNuevoProductoPedidoMasivo(ListaProductos)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false });
          setcarritoProdctos(result.dto.carritoProdctos);
          notificacion("Aviso", "Se agregaron productos al carrito");
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Detalle Pedidos", error.message ?? null);
        });
      });
  }

  render() {
    const { detallePedido, detalle, trakingDetalle, estado, loading } = this.state;
    const navigation = this.props.navigation
    const auth = this.context;
    let backColor = this.getBackGroundColorForTab(estado.estad, data.EstadoPedido);
    console.log(estado);
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Detalle del Pedido</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>Pedidos</li>
              <li><Link to='/historial-pedidos'>Historial de pedidos</Link></li>
              <li>Detalle del Pedido</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile"><Link to='/historial-pedidos' className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></Link>Detalle del pedido</h6>
          <div className="card">
            {estado == null ? null :
              <Badge className="desktop light mb-4" style={{ backgroundColor: backColor, alignSelf: 'flex-start', borderRadius: 15 }}>{estado.nomEstad}</Badge>
              // <Badge className="desktop light mb-4" style={{ backgroundColor: c.morado, alignSelf: 'flex-start', borderRadius: 15 }}>{estado.nomEstad}</Badge>
            }
            <div className="text-left detalle_servicio">
              <div>
                <p className='paragraph-2 mb-1 light' style={{ color: c.azulClaro }}>Número de pedido: <strong>{detallePedido.vbeln}</strong></p>
                <p className='paragraph-2 light' style={{ color: c.azulClaro }}>Total: <strong>{detallePedido.sWaers} {(Number(detallePedido.total)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</strong></p>
                <p className='paragraph-3 light mb-0' style={{ color: c.grisMedio }}>Fecha de pedido: {detallePedido.fechaPedido}</p>
              </div>
              <div className="pedido-servicio desktop"><h6>Servicio a {detallePedido.direc}</h6><span>Transportista {detallePedido.transportista}</span></div>
              <div className="ml-auto desktop">
                <div className="d-flex align-items-center">
                  <button
                    className='btn-block mt-0 mr-2'
                    onClick={() => { this.addPedidos(auth.carritoProdctos, auth.setcarritoProdctos, data.Pantalla) }}
                  >
                    <SvgAssets className="mr-2" icon="icon-carrito" fill={'#fff'} />AGREGAR AL CARRITO
                  </button>
                  <div id="tooltip-info" className="tooltip-leyenda" style={{}}>
                    <SvgAssets icon="icon-info" fill={c.azulClaro} />
                    <UncontrolledTooltip placement="left" target="tooltip-info" className="tooltip-leyenda">
                      <span className="light">Al seleccionar <span style={{ display: 'inline-block' }}>agregar al carrito</span> podrás modificar las cantidades</span>
                    </UncontrolledTooltip>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* {
              (trakingDetalle.length == 0) ? null :
                <div className="desktop card_desktop my-5">
                  <ul className="tracking">
                    {trakingDetalle.map((traking, index) => {
                      // let colorPill = this.getColorForTab(traking.codEstad, data.EstadoPedido, traking.color, traking.ultimo);
                      let colorPill = this.getColorForTab(traking.codEstad, data.EstadoPedido, true, traking.ultimo);
                      return (
                        <li className={colorPill.class} key={index}>
                          <Badge style={{ backgroundColor: colorPill.hex }}>{traking.estad}</Badge>
                          <span className="fecha">
                            {
                              (traking.tituloFecha == null) ?
                                (traking.codEstad == data.EstadoPedido.PorPagar) ?
                                  (<span>{traking.fechaPedido}<br/>Fecha máxima de pago<br></br>{traking.fechaVencimiento}</span>)
                                  :
                                  traking.fechaPedido
                                :
                                (<span>{traking.tituloFecha}<br></br>{traking.fechaPedido}</span>)
                            }
                          </span>
                          {
                            (traking.urlFactura == "" || traking.urlFactura == null || !traking.flagUrlFactura) ? null :
                              <button
                                className="btn-small"
                                onClick={() => this.loadFactura(traking.urlFactura)}
                              >
                                Factura n° {traking.nomFactura}<SvgAssets icon="icon-download-file" fill={c.rojoClaro} />
                              </button>
                          }
                        </li>
                      )
                    })}
                  </ul>
                </div>
            } */}
            <div className="pedido-servicio mobile text-center"><h6>Servicio a {detallePedido.direc}</h6><span>Transportista MARVISUR S.A.C</span></div>
            {(detalle.lenght == 0) ? null :
              <ListGroup flush className="container_840">
                <ListGroupItem>
                  <Row form>
                    <Col xs={3} md={5}>
                      <span className='paragraph-3 bold'></span>
                    </Col>
                    <Col xs={2} md={2}>
                      <span className='paragraph-3 bold' style={{ color: c.verdeClaro }}>Can.</span>
                    </Col>
                    <Col xs={4} md={3}>
                      <span className='paragraph-3 bold' style={{ color: c.morado }}>Precio Uni.</span>
                    </Col>
                    <Col xs={3} md={2}>
                      <span className='paragraph-3 bold' style={{ color: c.azulClaro }}>Total</span>
                      <div className="desktop">
                        {/* <TooltipLeyenda
                          color={c.celeste}
                          style={{ position: 'absolute', right: -30, top: -6 }}
                        /> */}
                        <div id="tooltip-info-2" className="tooltip-leyenda" style={{ position: 'absolute', right: -30, top: -6 }}>
                          <SvgAssets icon="icon-info" fill={c.azulClaro} />
                          <UncontrolledTooltip placement="top" target="tooltip-info-2" className="tooltip-leyenda">
                            <span>PVD: Precio Venta Dealer</span>
                          </UncontrolledTooltip>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </ListGroupItem>
                {detalle.map((pedido, index) => {
                  return (
                    <ListGroupItem>
                      <Row form>
                        <Col xs={3} md={5}>
                          <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: c.grisMedio }}>{pedido.maktx}</span>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>SKU: {pedido.matnr}</span>
                        </Col>
                        <Col xs={2} md={2}><span className='paragraph-2 bold' style={{ color: c.verdeClaro }}>{pedido.canti}</span></Col>
                        <Col xs={4} md={3}>
                          <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: c.morado }}>PVD {pedido.sWaers} {pedido.precio.toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
                          {/* <span className='paragraph-3' style={{ color: c.morado }}>PVP S/ 7.00</span> */}
                        </Col>
                        <Col xs={3} md={2}>
                          <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: c.azulClaro }}>{pedido.sWaers} {pedido.subto.toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
                        </Col>
                      </Row>
                    </ListGroupItem>
                  )
                })}

              </ListGroup>
            }
            {/* <div className="text-center mt-4 mobile">
              <button
                className='btn-block'
                onClick={() => { this.addPedidos(auth.carritoProdctos, auth.setcarritoProdctos, data.Pantalla) }}
              >
                <SvgAssets className="mr-2" icon="icon-carrito" fill={'#fff'} />AGREGAR AL CARRITO
              </button>
            </div> */}
            <div className="text-center mt-4 mobile">
              <div className="d-flex align-items-center">
                <button
                  className='btn-block mt-0'
                  style={{ minWidth: 'auto' }}
                  onClick={() => { this.addPedidos(auth.carritoProdctos, auth.setcarritoProdctos, data.Pantalla) }}
                >
                  <SvgAssets className="mr-2" icon="icon-carrito" fill={'#fff'} />AGREGAR AL CARRITO
                </button>
                <div id="tooltip-info-3" className="tooltip-leyenda ml-2" style={{}}>
                  <SvgAssets icon="icon-info" fill={c.azulClaro} />
                  <UncontrolledTooltip placement="top" target="tooltip-info-3" className="tooltip-leyenda" trigger="click">
                    <span className="light" style={{ fontSize: 9 }}>Al seleccionar <strong>agregar al carrito</strong> podrás modificar las cantidades</span>
                    <hr />
                    <span className="bold">PVD: Precio Venta Dealer</span>
                  </UncontrolledTooltip>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  getColorForTab = (estado, data, colorestado, ultimo) => {
    if (colorestado == true) {
      // if (colorestado == true && ultimo == true) {
      switch (estado) {
        case data.PorPagar:
          return { hex: c.naranja, class: "naranja" };
        case data.Entregado:
          return { hex: c.verde, class: "verde" };
        case data.Expirado:
          return { hex: c.rojoClaro, class: "rojo" };
        case data.EnPreparacion:
          return { hex: c.morado, class: "morado" };
        case data.Facturado:
          return { hex: c.amarillo, class: "amarillo" };
        case data.Pagado:
          return { hex: c.azul, class: "azul" };
        case data.Despachado:
          return { hex: c.celeste, class: "celeste" };
        case data.Anulado:
          return { hex: c.grisMedio, class: "grisMedio" };
        default:
          return { hex: c.azul, class: "azul" };
      }
    }
    else if ((colorestado == true) && (ultimo == false)) {
      return { hex: c.azul, class: "azul" };
    }
    else {
      return { hex: c.grisMedio, class: "grisMedio" };
    }
  }

  loadFactura = (url) => {
    window.open(url, "_blank");
    // Linking.openURL(url).catch(err => console.log("Couldn't load page", err));
  }

  getBackGroundColorForTab = (estado, data) => {
    switch (estado) {
      case data.PorPagar:
        return c.naranja;
      case data.Entregado:
        return c.verde;
      case data.Expirado:
        return c.rojoClaro;
      case data.EnPreparacion:
        return c.morado;
      case data.Facturado:
        return c.amarillo;
      case data.Pagado:
        return c.azul;
      case data.Despachado:
        return c.celeste;
      case data.Anulado:
        return c.grisMedio;
      default:
        return c.azulClaro;
    }
  }
}